import { JSX, useEffect, useState } from 'react';
import './addTodoList.css';
import TodoContent from './todoContent';
import {categories} from '../category/category'
import TodoManager from '../data/todoManager'
import TitleInput from '../../common/title/title';
import AddButton from '../../common/AddButton/addButton';
import Loading from '../../common/Loading/loading';

export interface TodoTask {
    _id?: string;  
    id: number;
    title: string;
    completed: boolean;
    category: categories,
    date: Date | null;
    content: string;
    noteId?: number;
}

const AddTodoList = (): JSX.Element => {

  const changeTodoTitle = (title: string) => {
    setNewTodo({ ...newTodo, title: title}); 
  };

  const changeTodoContent = (content: string) => {
    setNewTodo({ ...newTodo, content: content}); 
  };

  const changeTodoCategory = (category: categories) => {
    setNewTodo({ ...newTodo, category: category}); 
  };

  const changeTodoDate = (date: Date) => {
    setNewTodo({ ...newTodo, date: date}); 
  };

  const [isLoading, setIsLoading] = useState(false);
  const todoManager = TodoManager.getInstance();
  const [newTodo, setNewTodo] = useState<TodoTask>(todoManager.getDraftTodo());
    
  useEffect(() => {
    todoManager.saveDraftTodo(newTodo);
  }, [newTodo])

  const addTodo = async () => {
      if (newTodo.title.trim() !== '') {
        await add();
        setNewTodo({
          id: Date.now(),
          title: "",
          completed: false,
          category: 'Work',
          date: new Date(),
          content: "",
        });
      };
  };

  const add = async () => {
    try {
      setIsLoading(true);
      await todoManager.addTodo(newTodo);
      // Success handling
    } catch (error) {
      // Error handling in UI
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className='todo-container'>
      {/* Title */}
      <TitleInput title={newTodo.title} setTitle={changeTodoTitle}/>
      {/* Content */}
      <TodoContent 
        todoContent={newTodo.content} onContentChange={changeTodoContent}
        todoDate={newTodo.date} onDateChange={changeTodoDate}
        todoCategory={newTodo.category} onCategoryChange={changeTodoCategory}
      />
      {/* Add Button */}
      <AddButton title='Add' addFunction={addTodo}/>
      {isLoading && <Loading/>}
    </div>
  ); 
};
  
export default AddTodoList;